import { useDeleteUserDocument } from "../../api/user";
import { useDeleteConfirm } from "../../hooks/useDeleteConfirm";

export default function useDeleteDocumentModal() {
  const { mutateAsync } = useDeleteUserDocument();
  const confirmDelete = useDeleteConfirm("document", mutateAsync);

  const openDeleteModal = (document) => confirmDelete({ id: document.id });

  return openDeleteModal;
}
